"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  OK: 'ITEM_OK',
  INVALID: 'ITEM_INVALID'
};
exports["default"] = _default;